import React from 'react';
import { caseStudies } from '../../mock/content';
import { ArrowUpRight, Star } from 'lucide-react';
import CountUp from './CountUp';
import Reveal from './Reveal';

const CaseStudies = () => {
  return (
    <section className="bg-brand-soft py-20 md:py-24">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-brand-blue text-[12px] font-bold tracking-[0.16em] uppercase mb-4">
            Customer results
          </p>
          <h2 className="text-navy font-black tracking-[-0.01em] leading-[1.12] text-[32px] sm:text-[40px] md:text-[46px]">
            Real publishers. Real revenue.
          </h2>
          <p className="mt-6 text-body-muted text-[16px] leading-[1.7]">
            A slice of what happens when a B2B media brand adds a lead generation line under their name. Every number below is drawn from live partner campaigns.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {caseStudies.map((c, i) => (
            <Reveal
              key={c.brand}
              delay={i * 120}
              className="group bg-white rounded-2xl shadow-mk p-7 hover:shadow-mk-lg hover:-translate-y-1 transition-all duration-300 flex flex-col"
            >
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-1.5 text-brand-blue text-[11px] font-bold uppercase tracking-[0.12em] bg-brand-blue/10 rounded-full px-3 py-1">
                  <Star size={12} strokeWidth={2.5} />
                  {c.tag}
                </span>
                <ArrowUpRight
                  size={20}
                  className="text-body-muted group-hover:text-brand-blue group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                />
              </div>
              <h3 className="mt-5 text-navy text-[22px] font-bold">{c.brand}</h3>

              <div className="mt-6 pt-6 border-t border-slate-100">
                <div className="text-brand-blue text-[42px] sm:text-[48px] font-black leading-none tracking-tight">
                  <CountUp value={c.highlight} />
                </div>
                <p className="mt-2 text-body-muted text-[13.5px] font-medium">{c.highlightLabel}</p>
              </div>

              <div className="mt-6 grid grid-cols-2 gap-4">
                {c.metrics.map((m) => (
                  <div key={m.label}>
                    <div className="text-navy text-[20px] font-black tracking-tight">
                      <CountUp value={m.value} />
                    </div>
                    <p className="mt-1 text-body-muted text-[12.5px] leading-[1.4]">{m.label}</p>
                  </div>
                ))}
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="#call"
            className="inline-flex items-center justify-center h-11 px-7 rounded-md bg-brand-blue hover:bg-brand-blue-dark text-white text-[13px] font-bold uppercase tracking-[0.08em] shadow-mk-blue hover:shadow-mk-blue-hover hover:-translate-y-0.5 transition-all duration-300"
          >
            View all case studies
          </a>
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
